import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { apiErrorMessage } from "../lib/errors";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Logged in");
      navigate("/app");
    } catch (err) {
      toast.error(apiErrorMessage(err, "Login failed"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background grain relative flex items-center justify-center px-6">
      <div className="relative z-10 w-full max-w-md">
        <Link to="/" className="flex items-center gap-3 mb-10" data-testid="login-brand">
          <div className="w-8 h-8 border border-[#00D4FF] rotate-45 flex items-center justify-center">
            <span className="-rotate-45 text-[#00D4FF] font-mono text-xs font-bold">M</span>
          </div>
          <div>
            <div className="font-display text-lg leading-none">Martingale</div>
            <div className="overline leading-none mt-1">PLAYBOOK·TERMINAL</div>
          </div>
        </Link>

        <div className="overline mb-2">AUTHENTICATE</div>
        <h1 className="font-display text-4xl mb-8">Enter the terminal.</h1>

        <form onSubmit={submit} className="space-y-5 border border-zinc-800 p-8 bg-zinc-950/40">
          <div>
            <label className="overline block mb-2">EMAIL</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email"
              className="w-full bg-transparent border border-zinc-800 px-3 py-3 mono text-sm focus:outline-none focus:border-[#00D4FF]"
              placeholder="you@book.com"
            />
          </div>
          <div>
            <label className="overline block mb-2">PASSWORD</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password"
              className="w-full bg-transparent border border-zinc-800 px-3 py-3 mono text-sm focus:outline-none focus:border-[#00D4FF]"
              placeholder="••••••••"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="w-full py-3 bg-[#00D4FF] text-black font-mono uppercase tracking-widest text-xs disabled:opacity-50 hover:brightness-110"
          >
            {loading ? "Authenticating..." : "Enter"}
          </button>
        </form>

        <div className="mt-6 flex items-center justify-between text-sm text-zinc-500">
          <span>
            No account?{" "}
            <Link to="/register" className="text-[#00D4FF] underline" data-testid="login-to-register">
              Register
            </Link>
          </span>
          <Link
            to="/forgot-password"
            className="text-zinc-400 hover:text-[#00D4FF]"
            data-testid="login-forgot-link"
          >
            Forgot password?
          </Link>
        </div>
      </div>
    </div>
  );
}